import moment from "moment"
import Dropzone from "react-dropzone"

import { ICardDeliveryTabPrimary } from "./types"
import { getDeliveryAddressSuggestions } from "@api/finality/api"
import { ListenerAddressInput } from "@smart/listenerAddressInput"

import imgEmty from '@img/empty.svg'
import { IconDiplom, IconDownload, IconJobs, IconLink, IconScanFile, IconTelegram } from "@img/icons"

import { Empty, Flex, ToolTip, Textarea, Input, Divider, Button, Table, Container } from "@ui/index"
import css from './ui.module.scss'

/** Вкладка основная */
export const CardDeliveryTabPrimary = ({
    fieldsError,
    txtDeliveryToWhom, txtDeliveryAddress, txtIsAddressConfirmed, txtIsDeliveryCDEK,
    txtComment, listFiles, listListeners, listTrackNumbers,
    handlerOpenModalPreview, handlerDownloadFiles, handlerSendingTrackNumbers, 
    handlerSendingListenerFiles, handlerFileUploader, handlerOpenModalTrackNumber
}: ICardDeliveryTabPrimary) => {
    return <>
        <Flex gap="20px">
            <Flex gap="5px">
                <Divider prefix={<h4>Информация о доставке</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.deliveryToWhom ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" className="input_header">Кому (Ф.И.О.) <p>✸</p></Flex>
                            <Input placeholder="Кому (Ф.И.О.)" {...txtDeliveryToWhom} />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.deliveryAddress ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" className="input_header">Куда (Адрес доставки) <p>✸</p></Flex>
                            
                            <ListenerAddressInput
                                value={txtDeliveryAddress.value}
                                onChange={txtDeliveryAddress.setValue}
                                label="Куда (Адрес)"
                                loadSuggestions={getDeliveryAddressSuggestions}
                                suffix={
                                    <Flex gap="2px" flexDirection="row" className={css['delivery_switch']}>
                                        <span
                                            className={`${css['delivery_switch_btn']} ${txtIsDeliveryCDEK.value ? css['delivery_switch_btn_active'] : ''}`}
                                            onClick={(e) => { e.stopPropagation(); txtIsDeliveryCDEK.setValue(!txtIsDeliveryCDEK.value); txtIsAddressConfirmed.setValue(false) }}
                                        >СДЭК</span>
                                        <span
                                            className={`${css['delivery_switch_btn']} ${txtIsAddressConfirmed.value ? css['delivery_switch_btn_active'] : ''}`}
                                            onClick={(e) => { e.stopPropagation(); txtIsAddressConfirmed.setValue(!txtIsAddressConfirmed.value); txtIsDeliveryCDEK.setValue(false) }}
                                        >ПОЧТА</span>
                                    </Flex>
                                }
                            />

                            <p style={{color: 'red'}}><b>Внимание!</b> В начале должен быть <b>ИНДЕКС</b> места назначения.</p>
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Container type="secondary">
                <Flex width="100%">
                    <Divider prefix={<h4>Трек-номера</h4>} suffix={<Button size="sm" padding='0 10px' onClick={() => handlerOpenModalTrackNumber(true, 'new')}>Создать</Button>} />

                    <Table.Content isScrollVertical={false}>
                        {listTrackNumbers.value.length === 0
                            ? <Empty image={imgEmty} size='60px' title='Трек-номера отсутствуют' />
                            : listTrackNumbers.value.map((item, index) => (
                                <Table.Row
                                    key={index}
                                    className={css['table_grid_columns_content_track_numbers']}
                                    onClick={() => handlerOpenModalTrackNumber(true, 'edit', item.deliveryID, item.trackNumber, item.comment)}>
                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                        <p>{item.trackNumber}</p>
                                        <p style={{ opacity: '.8' }}>{item.comment}</p>
                                    </div>

                                    <span className="hiddenForMobile table_column_data_center">{moment(item.dateCreate).format('DD.MM.YYYY HH:mm:ss')}</span>

                                    <nav className={css['track_number_actions']}>
                                        <ToolTip title='Проверить статус доставки' placement="left">
                                            <a href={`https://www.pochta.ru/tracking#${item.trackNumber}`} target='_blank' rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                                                <Button variant="icon" size="md"><IconLink /></Button>
                                            </a>
                                        </ToolTip>

                                        <ToolTip title='Отправить в Telegram 👉 Доставка' placement="left">
                                            <Button variant="icon" size="md"
                                                onClick={(e) => { handlerSendingTrackNumbers(item.trackNumber); e.stopPropagation() }}
                                            ><IconTelegram /></Button>
                                        </ToolTip>
                                    </nav>
                                </Table.Row>
                            ))
                        }
                    </Table.Content>
                </Flex>
            </Container>

            <Flex gap="5px">
                <Divider prefix={<h4>Комментарий</h4>} />
                <Textarea placeholder="Комментарий" rows={5} value={txtComment.value} onChange={(e) => txtComment.setValue(e.target.value)} />
            </Flex>

            <Container type="secondary">
                <Flex width="100%">
                <Divider prefix={<h4>Слушатели по договору</h4>} />

                <Table.Content isScrollVertical={false}>
                    {listListeners.value.length === 0
                        ? <Empty image={imgEmty} size='60px' title='Слушатели отсутствуют' />
                        : listListeners.value.map((item, index) => (
                            <Table.Row key={index} className={css['table_grid_columns_content_listeners']}>
                                <Flex gap="6px" flexDirection="row" alignItems="center" justifyContent="center">
                                    <div id='tooltipBtnJob' style={{ cursor: 'help' }}>
                                        <ToolTip title={item.isFinalExamination === 1 ? 'Финальный экзамен сдан' : 'Финальный экзамен не сдан'} placement="bottomLeft">
                                            <IconJobs width='20px' height='20px' color={item.isFinalExamination === 1 ? 'green' : 'red'} />
                                        </ToolTip>
                                    </div>

                                    <div id='tooltipBtnPrint' style={{ cursor: 'help' }}>
                                        <ToolTip title={item.isPrint === 1 ? 'Диплом распечатан' : 'Диплом не распечатан'} placement="bottomLeft">
                                            <IconDiplom width='20px' height='20px' color={item.isPrint === 1 ? 'green' : 'red'} />
                                        </ToolTip>
                                    </div>
                                    
                                    <div id='tooltipBtnScan' style={{ cursor: 'help' }}>
                                        <ToolTip title={item.isScan === 1 ? 'Скан загружен' : 'Скан не загружен'} placement="bottomLeft">
                                            <IconScanFile width='18px' height='18px' color={item.isScan === 1 ? 'green' : 'red'} />
                                        </ToolTip>
                                    </div>
                                </Flex>

                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                    <p>{item.lastName} {item.firstName} {item.secondName}</p>
                                    <p style={{ opacity: '.8' }}>{item.phoneNumber} / {item.email || '----'}</p>
                                </div>

                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                    <p>{item.educationLevelName}</p>
                                    <p style={{ opacity: '.8' }} className='tRow-item-name-secondary'>{item.contractTypeNameShort} / {item.documentTypeNameShort} / {item.courseName}</p>
                                </div>

                                <span>{item.dateEducationStart}<br />{item.dateEducationEnd}</span>

                                <nav>
                                    <ToolTip title='Отправить в telegram 👉 Сканы дипломов' placement="left">
                                        <Button variant="icon" size="md" 
                                            onClick={(e) => { handlerSendingListenerFiles(item.contractListenerID); e.stopPropagation() }}
                                        ><IconTelegram /></Button>
                                    </ToolTip>
                                </nav>
                            </Table.Row>
                        ))
                    }
                </Table.Content>
                </Flex>
            </Container>

            <Container type="secondary">
                <Dropzone onDropAccepted={(files) => handlerFileUploader(files)} multiple={true}>
                    {({ getRootProps, getInputProps, isDragAccept, isDragActive }) => (
                        <div {...getRootProps({ className: isDragAccept ? `dropZone_container dropZone_dragAccept` : `dropZone_container`, onClick: event => event.stopPropagation() })} style={{ gap: '4px', display: 'flex', flexDirection: 'column' }}>
                            <input {...getInputProps()} />

                            <Divider prefix={<h4>Сканы файлов</h4>}
                                suffix={
                                    <Dropzone onDropAccepted={(files) => handlerFileUploader(files)}>
                                        {({ getRootProps, getInputProps }) => (
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <Button size='sm' padding={'0 10px'}>Загрузить</Button>
                                            </div>
                                        )}
                                    </Dropzone>
                                }
                            />

                            <Table.Content isScrollVertical={false}>
                                {listFiles.value.length === 0
                                    ? <Empty image={imgEmty} size='60px' title='Файлы отсутствуют' />
                                    : listFiles.value.map((item, index) => (
                                        <Table.Row key={index} className={css['table_grid_columns_content_files']} onClick={() => handlerOpenModalPreview(true, item.filePath, item.fileName)}>
                                            <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                <p>{item.fileName}</p>
                                                <p style={{ opacity: '.8' }}>Размер файла: {item.fileSize}</p>
                                            </div>

                                            <span className="hiddenForMobile table_column_data_center">{moment(item.dateCreate).format('DD.MM.YYYY')}<br />{moment(item.dateCreate).format('HH:mm:ss')}</span>

                                            <nav>
                                                <Button variant="icon" size="md" onClick={(e) => { handlerDownloadFiles(item.fileName, item.filePath); e.stopPropagation() }}>
                                                    <IconDownload />
                                                </Button>
                                            </nav>
                                        </Table.Row>
                                    ))
                                }
                            </Table.Content>
                        </div>
                    )}
                </Dropzone>
            </Container>
        </Flex>

        {/* <ToolTip anchorSelect="#tooltipBtnAddressOK" content='Адресс подтверждён' place="top-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnAddressNot" content='Адресс не подтверждён' place="bottom-end" /> */}
        
        {/* <ToolTip anchorSelect="#tooltipBtnTrackNumberLink" content='Проверить статус доставки' place="top-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnTrackNumberSend" content='Отправить в telegram 👉 ИКТ - Доставка' place="bottom-end" /> */}

        {/* <ToolTip anchorSelect="#tooltipBtnJob" content='Итоговая работа' place="bottom-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnPrint" content='Печать' place="top-end" /> */}
        {/* <ToolTip anchorSelect="#tooltipBtnScan" content='Скан' place="bottom-start" /> */}
    </>
}